<template>
  <router-link
    v-if="falhas.length > 0"
    class="router"
    to="/cadastros/tintometrico?aba=integracoes"
  >
    <div class="aviso-tintometrico">
      <fa-icon icon="exclamation-triangle" class="aviso-tintometrico__icone" />
      <p v-if="falhas.length === 1">
        A integração tintométrica <strong>{{ falhas[0].descricao }}</strong> está com falha
        {{ descreverFalha(falhas[0]) }}. Clique para ver os detalhes.
      </p>
      <p v-else>
        <strong>{{ falhas.length }} integrações tintométricas</strong> estão com falha de comunicação.
        Clique para ver todas.
      </p>
    </div>
  </router-link>
</template>

<script>
import { get } from '@/helpers/apiRequest';
import { moduloAutorizado } from '@/helpers/cargas';

export default {
  name: 'AvisoIntegracaoTintometrica',
  data() {
    return {
      falhas: [],
    };
  },
  methods: {
    carregarFalhas() {
      get('/admin/tintometrico/integracao/falhas')
        .then((json) => {
          this.falhas = (json && json.data) || [];
        })
        .catch(() => {
          this.falhas = [];
        });
    },

    descreverFalha(falha) {
      const partes = [];
      if (falha.falhaSync) partes.push('na sincronização');
      if (falha.falhasPendentes > 0) {
        partes.push(falha.falhasPendentes === 1
          ? 'em 1 pedido'
          : `em ${falha.falhasPendentes} pedidos`);
      }
      return partes.join(' e ');
    },
  },
  beforeMount() {
    // Só consulta/exibe se o usuário tiver acesso ao módulo tintométrico.
    if (moduloAutorizado('ADMIN_TINTOMETRICO')) {
      this.carregarFalhas();
    }
  },
};
</script>

<style scoped>
.router {
  width: 100%;
  display: flex;
  justify-content: center;
  text-decoration: none;
  margin-bottom: 25px;
}

.aviso-tintometrico {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 19px;
  color: #8c2a20;
  background-color: #fdeaea;
  border-left: 4px solid #c0392b;
  border-radius: 5px;
  font-size: larger;
}

.aviso-tintometrico:hover {
  background-color: #f9dcd9;
}

.aviso-tintometrico__icone {
  color: #c0392b;
  flex-shrink: 0;
}

.aviso-tintometrico p {
  margin-bottom: 0;
}
</style>
